import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { BackendStatusProvider } from '@/contexts/BackendStatusContext';
import { EventBusProvider } from '@/contexts/EventBusContext';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { OfflineBanner } from '@/components/OfflineBanner';
import { BackendStatusBanner } from '@/components/BackendStatusBanner';
import { router } from '@/router';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider forceTheme="light">
        <BackendStatusProvider>
          <AuthProvider>
            <EventBusProvider>
              <OfflineBanner />
              <BackendStatusBanner />
              <RouterProvider router={router} />
          <Toaster
            position="top-right"
            theme="light"
            expand
            visibleToasts={5}
            duration={4000}
            closeButton
            toastOptions={{
              classNames: {
                toast:
                  'group rounded-xl border border-border bg-background ring-1 ring-border/40 shadow-[var(--shadow-elevated)] font-[Area,system-ui,sans-serif] text-[13px] text-foreground',
                title: 'font-display text-[15px] tracking-tight text-foreground',
                description: 'text-muted-foreground text-[13px]',
                actionButton:
                  'bg-primary text-primary-foreground rounded-md px-3 py-1.5 text-[12px] font-bold',
                cancelButton:
                  'bg-interactive-bg text-foreground rounded-md px-3 py-1.5 text-[12px] font-bold',
                closeButton:
                  'bg-background border border-border text-muted-foreground hover:text-foreground',
                success: 'border-[var(--color-success)]/40',
                error: 'border-[var(--color-error)]/40',
                warning: 'border-[var(--color-warning)]/40',
                info: 'border-[var(--color-info)]/40',
              },
            }}
          />
            </EventBusProvider>
          </AuthProvider>
        </BackendStatusProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
